import { type AxiosResponse } from 'axios'
import api from '../utils/api'

export const exportPdf = async (termId: string): Promise<AxiosResponse> => {
  const response = await api.get(`/api/distributions/instructor/reports/export/pdf/?term_id=${termId}`, {
    responseType: 'blob',
    headers: {
      Accept: 'application/zip'
    }
  })
  return response
}

export const exportPDFByInstructorId = async (instructorId: string, termId: string): Promise<AxiosResponse> => {
  const response = await api.get(`/api/distributions/instructor/${instructorId}/reports/export/pdf/?term_id=${termId}`, {
    responseType: 'blob',
    headers: {
      Accept: 'application/zip'
    }
  })
  return response
}

export const exportCSV = async (termId: string): Promise<AxiosResponse> => {
  const response = await api.get(`/api/distributions/instructor/reports/export/csv/?term_id=${termId}`, {
    responseType: 'blob',
    headers: {
      Accept: 'application/zip'
    }
  })
  return response
}

export const exportCSVByInstructorId = async (instructorId: string, termId: string): Promise<AxiosResponse> => {
  const response = await api.get(`/api/distributions/instructor/${instructorId}/reports/export/csv/?term_id=${termId}`, {
    responseType: 'blob',
    headers: {
      Accept: 'application/zip'
    }
  })
  return response
}

export const getAllDistributionSeries = async (): Promise<AxiosResponse> => {
  return await api.get('/api/distribution_series/')
}

export const getInstructorDistributionsById = async (instructorId: string, params: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get(`/api/distributions/instructor/${instructorId}`, { params })
}

export const goLiveSectionApi = async (params: Record<string, any>): Promise<AxiosResponse> => {
  return await api.post(`/api/distributions/?slot_id=${params.slotId}&section_id=${params.sectionId}`)
}

export const getInstructorDistributions = async (params: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get('/api/distributions/instructor/', { params })
}

export const getAdminDistributions = async (params: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get('/api/distributions/admin/', { params })
}

export default {
  exportPdf,
  exportPDFByInstructorId,
  exportCSV,
  exportCSVByInstructorId,
  getAllDistributionSeries,
  getInstructorDistributionsById,
  getInstructorDistributions,
  goLiveSectionApi,
  getAdminDistributions
}
